import { render, staticRenderFns } from "./ImportValueList.vue?vue&type=template&id=88dae69a&"
import script from "./ImportValueList.vue?vue&type=script&lang=js&"
export * from "./ImportValueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports